import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/app/[locale]/reviews/reviews.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8def95401ce4598/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomerReviewCard"] */ "/tmp/8def95401ce4598/components/sections/CustomerReviewCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GuestReviewCard"] */ "/tmp/8def95401ce4598/components/sections/GuestReviewCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PartnerReviewsGrid"] */ "/tmp/8def95401ce4598/components/sections/PartnerReviewsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewSection"] */ "/tmp/8def95401ce4598/components/sections/ReviewSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustBadges"] */ "/tmp/8def95401ce4598/components/sections/TrustBadges.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/components/ui/Container.module.css");
